module.exports = __webpack_public_path__ + "static/media/sunny.2c3ff730.png";